// BlogRoutes.js
import React from 'react';
import { Routes, Route } from 'react-router-dom';
import AllBlogs from "../Pages/BlogIndex";
import BlogPage from "../Pages/BlogPage";

function BlogRoutes() {
    return (
        <Routes>
            <Route path="/" element={<AllBlogs />} />
            <Route path="/:id" element={<BlogPage />} />
        </Routes>
    );
}

export default BlogRoutes;
